import React from 'react'
import { Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { EventTypes, getPageSource, track } from '@mc/track-event'
import { FREE_TRIAL_I18N_NAMESPACE } from '../../../i18n'
import { useFreeTrial } from '../../../lib'

export const StickyFooter = () => {
  const { t } = useTranslation(FREE_TRIAL_I18N_NAMESPACE)
  const { trial } = useFreeTrial()

  const name = trial.advocate?.name ?? t('guestPass.footer.friendName')

  const onClick = ({ action }: { action: string }) => {
    track(EventTypes.PURCHASE_CLICK, {
      active_annual_pass: false,
      page_source: getPageSource(),
      page_path: window.location.pathname,
      type: 'all-access-pass',
      class: 'annual-pass',
      location: 'sticky_footer',
      href: paths.checkout,
      action,
    })
  }

  return (
    <div className='mc-bg-gray-100'>
      <div className='container mc-py-4'>
        <div className='d-flex justify-content-between'>
          <div>
            <p className='mc-text-h2 mc-text--brand mc-text--uppercase mc-mb-2 mc-mr-1'>
              {t('guestPass.footer.title', { name })}
            </p>
            <p className='mc-text-h8'>{t('guestPass.footer.description')}</p>
          </div>

          <div className='d-flex d-md-none'>
            <Button
              as='a'
              href={paths.checkout}
              onClick={() =>
                onClick({ action: t('guestPass.footer.cta.mobile') })
              }
            >
              {t('guestPass.footer.cta.mobile')}
            </Button>
          </div>
          <div className='d-none d-md-flex'>
            <Button
              as='a'
              href={paths.checkout}
              onClick={() =>
                onClick({ action: t('guestPass.footer.cta.desktop') })
              }
            >
              {t('guestPass.footer.cta.desktop')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
